import { Swiper } from 'swiper/bundle';

let heroSlider = document.getElementById('sliderHero');

if (heroSlider) {
  initializeSwiper(heroSlider);
}

function initializeSwiper(swiperInstance) {
  let sliderHeroOptions = {
    speed: 1000,
    simulateTouch: false,
    navigation: {
      disabledClass: 'slider-control-disabled',
      hiddenClass: 'slider-control-hidden',
      lockClass: 'slider-control-lock',
      nextEl: swiperInstance.querySelector('.slider-hero .slider-control-next'),
      prevEl: swiperInstance.querySelector('.slider-hero .slider-control-prev'),
    },
    on: {
      init: function () {
        var pagerCurent = this.el.querySelector('.slider-pager-current'),
          pagerTotal = this.el.querySelector('.slider-pager-total');

        if (pagerCurent && pagerTotal) {
          pagerCurent.innerHTML = '0' + (this.activeIndex + 1);
          pagerTotal.innerHTML = '0' + this.slides.length;
        }
      },
      slideChange: function () {
        var currentSlide = '0' + (this.realIndex + 1);
        this.el.querySelector('.slider-pager-current').innerHTML = currentSlide;
      },
    },
    slideActiveClass: 'slider-item-active',
  };
  let sliderHero = new Swiper(swiperInstance, sliderHeroOptions);

  sliderHero.on('slideChangeTransitionStart', function () {
    if (this.slides[this.realIndex].classList.contains('has-video')) {
      var video = this.slides[this.realIndex].getElementsByTagName('video');
      video[0].play();
    }
  });

  sliderHero.on('slideChange', function () {
    Array.from(this.slides).forEach(function (slide) {
      if (slide.classList.contains('has-video')) {
        var video = slide.getElementsByTagName('video');
        video[0].classList.add('pause');
        video[0].pause();
      }
    });
  });
}

export { initializeSwiper };
